export const environment = {
    production: true,
    name: "production",
    api: {
        translateLangs: "https://translate-develop.i-plan.us/languages",
        url: "https://srv.i-plan.us"
    }
};
